import config from '../common/config';
import React from 'react';
import { withRouter } from 'react-router-dom';
import qs from 'qs';
import { fromJS } from 'immutable';
import { connect } from 'react-redux';
import { Grid, Cell } from 'react-flexr';
import Checkbox from 'react-bootstrap/lib/Checkbox';
import Radio from 'react-bootstrap/lib/Radio';

import ProductCategory from '../common/product-category';
import { SearchPanel, SearchGroup, Slider } from '../common/search';
import TagFilter from '../common/tagFilter';
import Showcase from '../common/showcase';

const QUICKLOAN = 'Kviklån';
const CONSUMERLOAN = 'Forbrugslån';

const MAX_AMOUNT = 100000;
//const MAX_AMOUNT_QUICKLOAN = 10000;

const DEFAULT_LOAN_AMOUNT = 25000;
const UNLIMITED_LOAN = 100001;

const DEFAULT_AGE = 24;
const UNLIMITED_AGE = 30;

const DEFAULT_DURATION = 24;
const UNLIMITED_DURATION = 181;

const ALL_MSG = '';

function formatInterest(interests) {
  return interests
    .filter(Boolean)
    .map(interest => `${formatNumber(interest)}%`)
    .join(' - ');
}

function formatNumber(number) {
  return typeof number !== 'number'
    ? number
    : String(number)
        .replace(/\.([0-9]+)$/, ',$1')
        .replace(
          /^([0-9]{1,3})(([0-9]{3})+)(:?,.+)?$/g,
          (_, p1, p2, p3, p4) => `${p1}.${p2}${p4 || ''}`
        );
}

@connect(({ loan: { offers } }) => ({ offers }))
@withRouter
class Offers extends ProductCategory {
  constructor(props) {
    super(props);

    const q =
      __CLIENT__ &&
      qs.parse(props.location.search, {
        ignoreQueryPrefix: true
      }).q;

    const loanAmount =
      (q == Number(q) &&
        q > 1000 &&
        q < MAX_AMOUNT &&
        Math.ceil(q / 1000) * 1000) ||
      null;

    this.state = this.mapPropsToState(props, {
      offerType: 'lån',
      ...this.state,
      defaultFilters: { // FOR FILTERS_USED EPI
        loanAmount,
        age: null,
        duration: null,
        quickloan: false,
        consumerloan: true,
        tags: []
      },
      filters: {
        loanAmount,
        age: null,
        duration: null,
        quickloan: false,
        consumerloan: true,
        tags: [],
        ...(this.state.filters || {})
      }
    });
  }

  resetFilter() {
    const filters = {
      ...(this.state.filters || {}),
      age: null,
      duration: null,
      quickloan: false,
      consumerloan: true,
      tags: []
    };
    
    this.setState({
      filters,
      filter: this.createFilter(filters)
    });
  }

  serialiseOffer(offer) {
    const minInterest = offer.getIn(['interestRate', 'min']);
    const maxInterest = offer.getIn(['interestRate', 'max']);
    const interestRate = formatInterest(
      minInterest === maxInterest ? [maxInterest] : [minInterest, maxInterest]
    );

    const minYearly = offer.getIn(['annualCostInPercentage', 'min']);
    const maxYearly = offer.getIn(['annualCostInPercentage', 'max']);
    const yearlyInterest = formatInterest(
      minYearly === maxYearly ? [maxYearly] : [minYearly, maxYearly]
    );

    // New laws in Denmark per 1st of July 2020
    if (maxYearly > 25 || minYearly > 25 || !yearlyInterest) {
      return null;
    }

    const tags = offer.get('tags') ? offer.get('tags').toJS() : [];
    const manualTags = offer.get('manualTags') ? Array.from(offer.get('manualTags')) : [];
    const mergedTags = tags.reduce((acc, tag) => {
      if(!acc.includes(tag)) {
        acc.push(tag);
      }
      return acc;
    }, manualTags || []).filter(Boolean);

    const result = fromJS({
      id: offer.get('_id'),

      provider: offer.get('provider'),
      product: offer.get('product'),
      // logo: `${config.path.images}/${offer.get('imageUrl')}`,
      logo:
        offer.getIn(['image', 'hash']) &&
        `${config.images}${offer.getIn(['image', 'hash'])}`,
      link: `/redirect/${offer.get('uuid')}`,
      orderText: 'Beregn Lån',

      details: [
        {
          value: `${formatNumber(
            offer.getIn(['loan', 'min']) || ''
          )} - ${formatNumber(offer.getIn(['loan', 'max']) || '')}`,
          unit: 'kr.',
          label: 'Lånebeløb',
          size: '1/3'
        },
        {
          value: [
            offer.getIn(['duration', 'min']),
            offer.getIn(['duration', 'max'])
          ]
            .filter(Boolean)
            .join(' - '),
          unit: (offer.getIn(['duration', 'unit']) || '')
            .replace('days', 'dage')
            .replace('month', 'mdr.'),
          label: 'Løbetid',
          size: '1/3'
        },
        {
          value: interestRate || '-',
          label: 'Debitorrente',
          // mask: true,
          size: '1/3'
        },
        {
          value: yearlyInterest || '-',
          label: 'ÅOP',
          // mask: true,
          size: '1/3'
        },
        {
          value: offer.getIn(['requirements', 'age']) || '-', 
          unit: '',
          label: 'min. alder',
          size: '1/3'
        },
        {
          value: offer.getIn(['wait', 'approval'])
            ? offer
                .getIn(['wait', 'approval'])
                .replace(/minut(ter)?/i, 'min')
                .replace(/sekund(er)?/i, 'sek')
            : '-',
          label: 'Svartid',
          size: '1/3'
        }
      ],

      prices: [],

      price: {
        value: offer.getIn(['wait', 'approval'])
          ? offer
              .getIn(['wait', 'approval'])
              .replace(/minut(ter)?/i, 'min')
              .replace(/sekund(er)?/i, 'sek')
          : '-',
        label: 'Svartid'
      },

      usps: []
        .concat(mergedTags, offer.get('services').toJS())
        .filter(Boolean),

      remarks: {
        headline: 'Standardeksempel:',
        text: offer.get('example')
      },

      productDescription: offer.get('productDescription'),
      discountCode: offer.get('discountCode'),

      _raw: offer
    });

    return result;
  }

  hasShortAnswerTime(d) {
    if (d === null || typeof d === 'undefined') {
      return false;
    } // empty value in db is ' - '
    const arr = d.trim().split(' ');
    const timeValue = arr[0];
    const timeUnit = arr[1];
    return (timeUnit === 'time' && timeValue <= 1) || timeUnit !== 'dage';
  }

  createFilter(filters) {
    this.updateFiltersUsed(filters);
    return offers =>
      offers.filter(offer => {
        const tags = Array.from(offer.get('usps'));
        const services = Array.from(offer.getIn(['_raw', 'services']));
        const filteredTags = filters.tags;

        const lowerCaseTags = tags.map(i => i.toLowerCase());
        const lowerCaseServices = services.map(i => i.toLowerCase());
        const lowerCaseProvider = offer.get('provider').toLowerCase().trim().replace('-', ' ');

        for (let idx = 0; idx < filteredTags.length; idx++) {
          const tag = filteredTags[idx];
          if (
            !lowerCaseServices.includes(tag) &&
            !lowerCaseTags.includes(tag) && 
            !tags.includes(tag) &&
            !services.includes(tag) &&
            tag.toLowerCase() !== lowerCaseProvider) {
            return false;
          }
        }

        if (filters.loanAmount !== null) {
          if (
            filters.loanAmount !== UNLIMITED_LOAN &&
            offer.getIn(['_raw', 'loan', 'max']) < filters.loanAmount
          ) {
            return false;
          }
          if (
            filters.loanAmount !== UNLIMITED_LOAN &&
            offer.getIn(['_raw', 'loan', 'min']) > filters.loanAmount
          ) {
            return false;
          }
        }

        if (filters.age !== null) {
          if (
            filters.age !== UNLIMITED_AGE &&
            offer.getIn(['_raw', 'requirements', 'age']) > filters.age
          ) {
            return false;
          }
        }

        return true;
      });
  }

  createSearchDisplay(filters) {
    const arr = [];

    if (filters.loanAmount) {
      arr.push(`lånebeløb: ${filters.loanAmount} kr.`);
    }
    if (filters.duration) {
      arr.push(`løbetid: ${filters.duration} mdr.`);
    }
    if (filters.age) {
      arr.push(`alder: ${filters.age} år`);
    }

    return arr;
  }

  getLabelAmount = values => {
    if (this.state.filters.loanAmount === null) {
      return ALL_MSG;
    } else if (this.state.filters.loanAmount === UNLIMITED_LOAN) {
      return 'Alle';
    }
    const value = Math.round(values[0]).toString();
    return `${value.replace(/^([0-9]{1,3})([0-9]{3})$/, '$1.$2')} kr.`;
  };

  getLabelAge = () => {
    // return this.state.filters.age === null ? ALL_MSG : `${parseInt(values)} år`;
    const { age } = this.state.filters;
    if (age) {
      if (age === UNLIMITED_AGE) {
        return '30+ år';
      }
      return `${age} år`;
    }
    return '';
  };

  getLabelDuration = values => {
    if (this.state.filters.duration === null) {
      return ALL_MSG;
    } else if (this.state.filters.duration === UNLIMITED_DURATION) {
      return 'Alle';
    }
    return !Number(values[0]) /* || this.state.filters.quickloan*/
      ? ''
      : `${Math.round(values[0])} mdr.`;
  };

  render() {
    const { offers, filter, filters, showcases } = this.state;

    const loanAmount = {
      name: 'loanAmount',
      connect: 'lower',
      disconnected: filters.loanAmount === null,
      headline: ['Lånebeløb', this.getLabelAmount],
      units: ['1.000 kr.', '100.000 kr. | Alle'],
      min: 1000,
      max: UNLIMITED_LOAN,
      range: {
        min: [1000, 1000],
        '20%': [12000, 2000],
        '35%': [20000, 2500],
        '50%': [DEFAULT_LOAN_AMOUNT, 5000],
        '70%': [50000, 10000],
        max: [UNLIMITED_LOAN]
      },
      defaultStart: [filters.loanAmount || DEFAULT_LOAN_AMOUNT],
      onSlide: this.sliderOnChange
    };

    return (
      <Grid>
        <Cell size='3/12' portable='1/1'>
          <SearchPanel
            title={'Lån'}
            filter={filter}
            results={offers}
            filterTexts={this.createSearchDisplay(filters)}
          >
            <SearchGroup>
              <Slider {...loanAmount} />
            </SearchGroup>
            <SearchGroup>
              <Slider
                name='age'
                connect='lower'
                disconnected={filters.age === null}
                headline={['Alder', this.getLabelAge]}
                units={['18 år', '30+ år']}
                min={18}
                max={30}
                range={{
                  min: [18, 1],
                  '50%': [DEFAULT_AGE, 1],
                  max: [UNLIMITED_AGE]
                }}
                defaultStart={[filters.age || DEFAULT_AGE]}
                onSlide={this.sliderOnChange}
              />
            </SearchGroup>
            <SearchGroup disabled={false /*filters.quickloan*/}>
              <Slider
                name='duration'
                connect='lower'
                disconnected={filters.duration === null}
                headline={['Løbetid', this.getLabelDuration]}
                units={['3 måneder', '15 år | Alle']}
                min={0}
                max={180}
                range={{
                  min: [3, 3],
                  '50%': [DEFAULT_DURATION, 6],
                  '70%': [72, 8],
                  '80%': [80, 40],
                  '90%': [120, 60],
                  max: [UNLIMITED_DURATION]
                }}
                disabled={false /*filters.quickloan*/}
                defaultStart={[filters.duration || DEFAULT_DURATION]}
                onSlide={this.sliderOnChange}
              />
            </SearchGroup>
            {/* {this.props.category === 'quickloan' ? (
            ): null} */}

            <TagFilter
              headline={'Tags'}
              feed={this.state.feed}
              offerType={this.state.offerType}
              items={offers}
              filters={filters}
              checkboxOnChange={this.tagsOnChange}
            />
          </SearchPanel>
        </Cell>
        <Cell>
          <Showcase list={showcases} orderText='Ansøg' site_id={this.state.siteId} feed={this.state.feed} url={this.state.url} filters_used={this.state.filtersUsed}/>
          {this.renderResults(null, this.resetFilter.bind(this))}
        </Cell>
      </Grid>
    );
  }
}

export default Offers;
